//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import useI18N from '@/translations/i18n'

export default {
  props: {},
  setup() {
    const $t = useI18N()
    return { $t }
  },
}
